import { ReactNode } from "react";

interface Props {
  title: string;
  body: string;
  /** Optional custom illustration; defaults to the empty-clipboard image. */
  icon?: ReactNode;
}

const EmptyState = ({ title, body, icon }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center px-10 mb-10">
      {icon ?? (
        <img
          src="/images/empty-clipboard.svg"
          alt="No data"
          className="h-24 my-4"
        />
      )}
      <h3 className="text-lg font-semibold text-gray-700 mb-2">{title}</h3>
      <p className="text-gray-500 text-sm text-center">{body}</p>
    </div>
  );
};

export default EmptyState;
